import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useDraggableScroll } from '@belong/common/useDraggableScroll';
import { TabList } from '@reach/tabs';
import clsx from 'clsx';
import css from './List.module.css.js';
import { useAnimationContext } from './use-animation-context.js';

function List({
  className,
  ...props
}) {
  const ref = useRef(null);
  const {
    onMouseDown
  } = useDraggableScroll(ref, {
    direction: 'horizontal'
  });
  const {
    isDraggable
  } = useAnimationContext();
  return jsx(TabList, {
    ...props,
    className: clsx(className, {
      [`${css.dragContainer}`]: isDraggable
    }),
    ref: ref,
    ...(isDraggable ? {
      onMouseDown
    } : {})
  });
}

export { List };
